import axios from 'axios';
import * as qs from 'qs';
import { message } from 'antd';
import { Dialog } from 'antd-mobile';

const ERROR_STATUS = {
    401: '未授权，请登录',
    403: '无权限，请确认',
    404: '请求异常',
    408: '请求超时',
    500: '服务器内部错误',
    501: '服务未实现',
    502: '服务不可用',
    504: '网关超时',
    505: 'HTTP版本不支持',
};

// 环境变量
// const isPrd = process.env.NODE_ENV === 'production';

// 配置请求超时时间
axios.defaults.timeout = 60000;

// 区分开发环境还是生产环境基础URL
// 优先使用环境变量配置，如果没有配置则使用 window.location.origin
export const basciUrl = process.env.REACT_APP_BASE_URL || window.location.origin;
axios.defaults.baseURL = basciUrl;

// 跨域是否允许携带凭证，允许保存cookie;
axios.defaults.withCredentials = true;

/**
 * 设置post请求头
 * application/json;charset=UTF-8   JSON格式
 * application/x-www-form-urlencoded;charset=UTF-8  Form表单格式
 */
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';

// 声明一个 Map 用于存储每个请求的标识 和 取消函数
const pending = new Map();
/**
 * 添加请求
 * @param {Object} config
 */
const addPending = config => {
    // const url = [
    //     config.method,
    //     config.url,
    //     qs.stringify(config.params),
    //     qs.stringify(config.data),
    // ].join('&');
    // config.cancelToken =
    //     config.cancelToken ||
    //     new axios.CancelToken(cancel => {
    //         if (!pending.has(url)) {
    //             // 如果 pending 中不存在当前请求，则添加进去
    //             pending.set(url, cancel);
    //         }
    //     });
};
/**
 * 移除请求
 * @param {Object} config
 */
const removePending = config => {
    // const url = [
    //     config.method,
    //     config.url,
    //     qs.stringify(config.params),
    //     qs.stringify(config.data),
    // ].join('&');
    // if (pending.has(url)) {
    //     // 如果在 pending 中存在当前请求标识，需要取消当前请求，并且移除
    //     const cancel = pending.get(url);
    //     cancel(url);
    //     pending.delete(url);
    // }
};
/**
 * 清空 pending 中的请求（在路由跳转时调用）
 */
export const clearPending = () => {
    for (const [url, cancel] of pending) {
        cancel(url);
    }
    pending.clear();
};

// 请求拦截
axios.interceptors.request.use(
    config => {
        removePending(config); // 在请求开始前，对之前的请求做检查取消操作
        addPending(config); // 将当前请求添加到 pending 中

        // 设置_t传值，防止浏览器缓存请求
        if (config.url.indexOf('?') !== -1) {
            config.url += `&_t=${new Date().getTime()}`;
        } else {
            config.url += `?_t=${new Date().getTime()}`;
        }
        // `transformRequest` 允许在向服务器发送前，修改请求数据
        // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
        // 后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
        if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            config.transformRequest = [
                (data, headers) => {
                    return qs.stringify(data, {
                        allowDots: true,
                    });
                },
            ];
        }
        // `paramsSerializer` 是一个负责 `params` 序列化的函数
        config.paramsSerializer = params => {
            // console.log(params);
            return qs.stringify(params, { arrayFormat: 'repeat' });
        };
        // 设置请求token
        const token = window.sessionStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = token; // 将token放到请求头发送给服务器
        }

        const visitToken = window.sessionStorage.getItem('visitorToken');
        if (visitToken) {
            config.headers.token = visitToken; // 将visitToken放到请求头发送给服务器
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

// 响应拦截
axios.interceptors.response.use(
    response => {
        removePending(response); // 在请求结束后，移除本次请求
        const { usertype } = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
        if (response.status === 401) {
            if (response.errCode === 402) {
                message.error('请重新登录。');
                sessionStorage.removeItem('visitorToken');
                console.log(response);
                setTimeout(() => {
                    window.location.href = `${basciUrl}/visitorApplyLogin`;
                }, 100);
                return;
            } else {
                message.error('登录失效，请重新登录。');
                sessionStorage.clear();
                setTimeout(() => {
                    window.location.href = `${basciUrl}/${
                        usertype === 'admin' ? 'adminLogin' : 'login'
                    }`;
                }, 100);
                return;
            }
        }
        // 导出接口直接返回流文件，将其包装成通用响应参数
        if (response.config.url.includes('api/check_in_record/v1/vist_registration/download')) {
            response.data = {
                success: true,
                file: response.data,
            };
        }

        if (response.config.url.includes('api/check_in_record/statics/v1/download')) {
            response.data = {
                success: true,
                file: response.data,
            };
        }

        if (response.config.url.includes('api/wait_application/statics/v1/download')) {
            response.data = {
                success: true,
                file: response.data,
            };
        }

        // 导出接口直接返回流文件，将其包装成通用响应参数
        if (response.config.url.includes('api/check_in_record/v1/download')) {
            response.data = {
                success: true,
                file: response.data,
            };
        }
        // 导出接口直接返回流文件，将其包装成通用响应参数
        if (response.config.url.includes('api/wait_application/v1/wait_application/excel')) {
            response.data = {
                success: true,
                file: response.data,
            };
        }

        if (response.config.url.includes('api/check_in_change/v1/download')) {
            response.data = {
                success: true,
                file: response.data,
            };
        }

        if (response.config.url.includes('api/check_in_record/conditionStatistics/download')) {
            response.data = {
                success: true,
                file: response.data,
            };
        }

        // TODO: 后端返回的数据格式需要确认 success
        // 如果是 dashboard 统计接口，直接返回数据（后端返回的是直接数据，不是包装的 success 格式）
        if (response.config.url.includes('api/dashboard/v1/statistic')) {
            return response.data;
        }

        if (!response.data || !response.data.success) {
            let errMsg = ERROR_STATUS[response.status] || '服务器异常';
            if (response.data && response.data.errMsg) {
                errMsg = response.data.errMsg;
            }
            message.error(errMsg);
        }
        return response.data || { success: false };
    },
    error => {
        let errMsg = '服务器异常';
        if (error && error.response && error.response.status) {
            const { usertype } = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
            if (error.response.status === 401) {
                errMsg = '登录失效，请重新登录。';
                sessionStorage.clear();
                setTimeout(() => {
                    window.location.href = `${basciUrl}/${
                        usertype === 'admin' ? 'adminLogin' : 'login'
                    }`;
                }, 100);
            } else if (error.response.status === 402) {
                message.error('请重新登录。');
                sessionStorage.removeItem('visitorToken');
                setTimeout(() => {
                    window.location.href = `${basciUrl}/visitorApplyLogin`;
                }, 100);
                return;
            } else {
                errMsg = ERROR_STATUS[error.response.status];
                if (error.response.data && error.response.data.errMsg) {
                    errMsg = error.response.data.errMsg;
                }
            }
        }
        // 非请求取消，抛出异常
        if (!axios.isCancel(error)) {
            if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                Dialog.alert({
                    content: `${errMsg}`,
                });
            } else {
                message.error(errMsg);
            }
        }
        return { success: false };
    },
);

export default axios;
